import { css } from 'styled-components'

export const CookieControl = css`
	#ccc {
		#ccc-notify {
			h3,
			p {
				font-family: 'BrandonText' !important;
			}

			.ccc-notify-button {
				border-radius: 2px !important;
				border: 1px solid #181c21 !important;
				text-transform: uppercase !important;
				font-family: 'BrandonText';
				font-weight: 700;
				letter-spacing: 0.8px;
				span {
					color: inherit !important;
					border: none;
				}
			}

			#ccc-notify-accept {
				background-color: #181c21;
				color: #fff;
			}
		}

		.ccc-panel {
			h2,
			h3,
			p {
				font-family: 'BrandonText' !important;
			}

			.checkbox-toggle {
				background-color: #fff;
				border: 2px solid black !important;
			}

			.checkbox-toggle-on,
			.checkbox-toggle-off {
				color: #181c21 !important;
			}

			#ccc-recommended-settings {
				background-color: #181c21;
				color: #fff;
				border-radius: 2px !important;
				border: 1px solid #181c21 !important;
				text-transform: uppercase !important;
				font-family: 'BrandonText';
				font-weight: 700;
				letter-spacing: 0.8px;
				span {
					color: inherit !important;
					border: none;
				}
			}

			#ccc-dismiss-button {
				background-color: transparent;
				color: #181c21;
				border-radius: 2px !important;
				border: 1px solid #181c21 !important;
				text-transform: uppercase !important;
				font-family: 'BrandonText';
				font-weight: 700;
				letter-spacing: 0.8px;
				span {
					color: inherit !important;
					border: none;
					background: none !important;
				}
			}
		}
	}
`
